import React from "react";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export default class ButtonLoading extends React.Component {
  render() {
    const { loading, startIcon, disabled, children, ...other } = this.props;
    const icon = loading ? <CircularProgress size={20} /> : startIcon;
    const isDisabled = loading ? true : disabled;
    const hasIcon = !!icon;
    const hasText = !!children;

    return (
      <Button
        {...other}
        disabled={isDisabled}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: hasIcon && hasText ? "4px" : 0,
        }}
      >
        {React.cloneElement(icon)}
        {children}
      </Button>
    );
  }
}
